import React, { useEffect, useState } from 'react';
import { List, ListItem, Title } from '@icarros/ids-react';
import { useAdContext } from '../../../store/contexts/ad';
import { ListItemModifier, OpenEditTitleWrapper, OpenEditWrapper } from './style';
import { useAd } from '../../../store/hooks/useAd';
import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useQuery } from '@tanstack/react-query';
import { getOptionals } from '../../../services/Edits.service';
import { GET_OPTIONALS } from '../../../queries';

const AUTO_ID = 14;
const MANUAL_PLACEHOLDER = undefined;

const gears = [
  {
    label: 'automático',
    value: AUTO_ID
  },
  {
    label: 'manual',
    value: MANUAL_PLACEHOLDER
  }
];

export function GearForm(): JSX.Element {
  const { setCurrentContent, loading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent } = useAdContext();
  const { opcionais } = currentAd?.veiculo || {};
  const isAuto = opcionais?.find(item => item.id === AUTO_ID);

  const [selectedRadio, setSelectedRadio] = useState(isAuto ? AUTO_ID : MANUAL_PLACEHOLDER);

  const { data, isInitialLoading } = useQuery({
    queryKey: [GET_OPTIONALS],
    queryFn: () => getOptionals()
  });

  useEffect(() => {
    setValueIsDifferentFromCurrent(selectedRadio !== isAuto?.id);
  }, [selectedRadio, isAuto, setValueIsDifferentFromCurrent]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar dados do veículo</Title>
        <Title variant="default" contrast="light">
          qual o tipo de câmbio do seu carro?
        </Title>
      </OpenEditTitleWrapper>

      {isInitialLoading && <Loading />}

      <List>
        {gears.map(gear => (
          <ListItemModifier key={gear.label}>
            <ListItem
              label={gear.label}
              variant="selector"
              radioOnChange={() => setSelectedRadio(gear.value)}
              radioValue={gear.value}
              radioChecked={gear.value === selectedRadio}
              selectorName={gear.label}
              selectorVariant="radio"
            />
          </ListItemModifier>
        ))}
      </List>

      {!(isInitialLoading && selectedRadio === isAuto?.id) && (
        <SaveFormContent
          loading={loading}
          isBody
          isDisabled={selectedRadio === isAuto?.id}
          handleClick={() => {
            const safeOpcionais = opcionais ? opcionais : [];
            const safeOptionals = data?.find(item => item.id === AUTO_ID);
            if (!safeOptionals) return;
            const result =
              selectedRadio === AUTO_ID
                ? [...safeOpcionais, safeOptionals]
                : opcionais?.filter(item => item.id !== AUTO_ID);
            setCurrentContent({
              veiculo: {
                opcionais: result
              }
            });
          }}
        />
      )}
    </OpenEditWrapper>
  );
}
